import { NavBar } from 'antd-mobile'
import React from 'react'
import { Outlet } from 'react-router'
import MainPageContainer from '../../components/containers/mainPage'
import SettingPopup from '../../components/settingPopup'
import { usePageNav } from '../../zustand/handlers'
import { BodyWrapper, NavbarWrapper } from './styles'

function MainPage() {
    const pageNav = usePageNav();
    return (
        <MainPageContainer>
            <NavbarWrapper >
                <NavBar
                    // right={<SettingPopup />}
                    backIcon={false}>{pageNav.current?.title}</NavBar>
            </NavbarWrapper>
            <BodyWrapper>
                <Outlet />
            </BodyWrapper>
            {/* <FooterWrapper>
                <BottomBar />
            </FooterWrapper> */}
        </MainPageContainer>
    )
}

export default MainPage